import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";

import styles from "./requestStripeConnectAccountStyles";
import ApiUser from "../../../API/ApiUser";
import ApiTour from "../../../API/ApiTour";
import RequestStripeConnectAccountView from "./requestStripeConnectAccountView";

class RequestStripeConnectAccountComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTours: [],
      companyName: "",
      representativeName: "",
      representativeFirstName: "",
      siret: "",
      streetAddress: "",
      city: "",
      zipCode: "",
      phone: "",
      comment: "",
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      tours: [],
      isLoading: true,
      redirectToAccount: false,
    };

    this.resetErrorAlert = this.resetErrorAlert.bind(this);
    this.resetSuccessAlert = this.resetSuccessAlert.bind(this);
  }

  componentDidMount() {
    document.title = "Demande de compte Stripe Connect | Landing Zone";
    this.getUserData();
    this.getUserTours();
  }

  resetErrorAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showError: false,
      errorMessage: "",
    }));
  }

  resetSuccessAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showSuccess: false,
      successMessage: "",
    }));
  }

  async getUserData() {
    const response = await ApiUser.getAccount();
    if (response.status === 200) {
      const userData = response.data;
      let address = ["", "", ""];
      if (userData.address) {
        address = userData.address.split(";");
      }
      this.setState({
        companyName: userData.companyName || "",
        representativeName: userData.lastname || "",
        representativeFirstName: userData.firstname || "",
        siret: userData.companySiret || "",
        streetAddress: address[0] || "",
        city: address[1] || "",
        zipCode: address[2] || "",
        phone: userData.phoneNumber || "",
      });
    }
  }

  async getUserTours() {
    const response = await ApiTour.getTours();
    if (response.status === 200) {
      this.setState({
        tours: response.data,
        isLoading: false,
      });
    }
  }

  handleTourSelection = (event) => {
    this.setState({
      selectedTours: event.target.value,
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { t } = this.props;

    if (!this.state.selectedTours.length) {
      this.setState({
        showError: true,
        errorMessage: t("request_stripe_connect.error.select_tours"),
        showSuccess: false,
      });
      return;
    }

    try {
      const response = await ApiUser.requestStripeAccount(
        this.state.selectedTours,
        this.state.companyName,
        this.state.representativeName,
        this.state.representativeFirstName,
        this.state.siret,
        this.state.streetAddress,
        this.state.city,
        this.state.zipCode,
        this.state.phone,
        this.state.comment
      );

      if (response.status === 200) {
        this.setState({
          showSuccess: true,
          successMessage: t("request_stripe_connect.success.request_sent"),
          showError: false,
          redirectToAccount: true,
        });
      } else if (response.data?.message === "siret-invalid") {
        this.setState({
          showError: true,
          errorMessage: t("request_stripe_connect.error.invalid_siret"),
          showSuccess: false,
        });
      } else {
        this.setState({
          showError: true,
          errorMessage: t("request_stripe_connect.error.unknown"),
          showSuccess: false,
        });
      }
    } catch (error) {
      this.setState({
        showError: true,
        errorMessage: t("request_stripe_connect.error.unknown"),
        showSuccess: false,
      });
    }
  };

  render() {
    const { classes } = this.props;

    if (this.state.redirectToAccount) {
      return (
        <Redirect to="/user/account?requested_stripe_connect_account=true" />
      );
    }

    return (
      <RequestStripeConnectAccountView
        {...this.props}
        state={this.state}
        handleTourSelection={this.handleTourSelection}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        resetErrorAlert={this.resetErrorAlert}
        resetSuccessAlert={this.resetSuccessAlert}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withTranslation()(RequestStripeConnectAccountComponent)
);
